<template>
  <div class="settings">
    <div class="settings-actions_managers">
        <div class="settings-actions__delete">
            <span v-if="selectedUsers.length > 0" class="settings-actions__delete-info">
              {{ `${$tr('common.selectedManagers', selectedUsers.length, {
                is_pluralization: true
              })} ${selectedUsers.length} ${$tr('settings.manager', selectedUsers.length, {
                is_pluralization: true
              })}` }}
            </span>

            <vbutton
              v-if="showDeleteButton"
              class="settings-actions__delete-container"
              color="transparent"
              type="icon"
              icon="icon-bin"
              v-tooltip.top-center="$tr('common.iconTooltips.deleteSelectedManagers')"
              :disabled="!isUsersSelected"
              @click="handleRemoving" />
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showDeleteButton: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    selectedUsers () {
      return this.$store.getters['users/selectedUsers'] || []
    },

    isUsersSelected () {
      return this.selectedUsers.length > 0
    },
  },

  methods: {
    handleRemoving () {
      const text = this.$tr('common.iconTooltips.finallyRemoveSelectedManagers')

      if (confirm(text)) {
        this.deleteUsers()
      }
    },

    deleteUsers () {
      if (this.isUsersSelected) {
        this.$store.dispatch('users/deleteUsers', this.selectedUsers)
      }
    },
  }
}
</script>

<style lang="scss" scoped>

.settings {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &_managers {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__delete {
    margin-right: 10px;
    display: flex;
  }

  &__delete-info {
    display: flex;
    align-items: center;
    font-size: 14.3px;
    white-space: nowrap;
    color: #333;
  }

  &__delete-container {
    margin-left: 15px;
  }

  &__button {
    width: 150px !important;
  }
}
</style>
